import React from "react";

import { Ico } from "./malluIcons";
import { MalluLockup } from "./malluMark";

/**
 * Cartão Mallu Pay (mock). `large` é a versão da seção "Cartão";
 * a compacta flutua ao lado do celular no hero.
 */
export const MalluCardMock = ({ t, large = false }) => (
  <div className={`pp-card-mock${large ? " pp-card-mock--lg" : ""}`}>
    <div className="pp-card-lines" />
    <div className="pp-sheen" style={large ? undefined : { animationDelay: "1.5s" }} />
    <div className="pp-card-row">
      <MalluLockup />
      <Ico name="nfc" size={large ? 26 : 22} color="rgba(255,255,255,.7)" />
    </div>
    <div className="pp-card-chip-row">
      <div className="pp-chip">
        {large ? (
          <>
            <i />
            <i />
            <i />
            <i />
          </>
        ) : null}
      </div>
      <div className="pp-card-num">{large ? t("card.mock.number") : t("card.mock.numberShort")}</div>
    </div>
    <div className="pp-card-foot">
      <div>
        <div className="pp-card-holder">{t("card.mock.holder")}</div>
        {large ? <div className="pp-card-valid">{t("card.mock.valid")}</div> : null}
      </div>
      <div className="pp-card-slogan">
        {t("card.mock.slogan1")}
        <br />
        {t("card.mock.slogan2")}
      </div>
    </div>
  </div>
);
